import { render, staticRenderFns } from "./LocalArmazenamentoForm.vue?vue&type=template&id=2efa6310"
import script from "./LocalArmazenamentoForm.vue?vue&type=script&lang=js"
export * from "./LocalArmazenamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports